export default function UploadFile() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="97"
      height="62"
      viewBox="0 0 97 62"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M79.2676 26.0915C79.2676 25.8333 79.3107 25.5752 79.3107 25.3171C79.3107 11.324 68.0949 0 54.2598 0C44.2779 0 35.7034 5.89818 31.6768 14.4236C29.9228 13.5405 27.9529 13.0243 25.8739 13.0243C19.4866 13.0243 14.1598 17.7385 13.1424 23.8958C5.47833 26.522 0 33.8204 0 42.4097C0 53.2164 8.6828 62 19.3783 62H41.5714V44.7778H31.1355L48.5 26.7592L65.8647 44.7558H55.4286V61.978H79.3107C89.0971 61.978 97 53.9051 97 44.0243C97 34.1433 89.054 26.1134 79.2676 26.0915Z"
        fill="#ADABFF"
      />
    </svg>
  );
}
